import { useSelector } from "react-redux";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";
import BizDevelopmentDashboardMobile from "../../../components/BizDevelopment/Dashboard/DashboardMobile/BizDevelopmentDashboardMobile";

const BizDevelopmentDashboardMobileScreen = () => {
  const userData = useSelector(selectUserData);
  const hasBizDevelopmentDashboardPermission = CheckPermissions(
    userData?.data?.products?.paid_traffic,
    "performance_analysis",
    "view_Bizdev_dashboard",
  );

  // need to check if the user has permission to view the Biz Development Dashboard

  return (
    <>
      {hasBizDevelopmentDashboardPermission ? (
        <BizDevelopmentDashboardMobile />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default BizDevelopmentDashboardMobileScreen;
